import { ReactNode, memo, ReactElement } from 'react'
import { Stack, Typography, ListItem, ListItemAvatar } from '@mui/material'
import { styled } from '@mui/material/styles'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import hostConf from '$config/frontend'
import { TextWithSkeleton } from '$common/text-with-skeleton'
import { VerifiedAccount } from '$common/icons/verified-account'
import { useDisplayedConnectionStatus } from '$comp/main/react-hook'
import { AvatarBase } from '$common/avatar/avatar-base'
import { RemovePersonIcon } from '$common/icons/remove-person'
import { getAvatarText } from '$func/avatar-text'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const StyledListItem = styled(ListItem)`
  box-sizing: border-box;
  padding: 4px 8px;
  overflow: hidden;
  .MuiListItemAvatar-root {
    min-width: 40px;
  }
  cursor: pointer;
`
const InfoContainer = styled(Stack)`
  width: 100%;
  justify-content: center;
  margin-right: 8px;
  overflow: hidden;
`

const StyledPrimaryText = styled(Typography)`
  margin-left: 4px;
`

const Container = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  overflow: hidden;
`

interface Props {
  avatarSrc: string
  avatarBackgroundColor?: string
  deleted?: boolean
  primaryText: string
  onClick: () => unknown
  secondaryText?: string | ReactElement
  verified?: boolean
  callElement?: ReactElement | null
  avatarElement?: ReactNode
}

function RoomAppBarInfoComponent({
  avatarSrc,
  avatarBackgroundColor = '',
  deleted = false,
  primaryText,
  secondaryText = '',
  verified = false,
  callElement = null,
  onClick,
  avatarElement,
}: Props) {
  const connectionStatus = useDisplayedConnectionStatus()

  return (
    <Container>
      <StyledListItem onClick={onClick}>
        <ListItemAvatar>
          {avatarElement ? (
            avatarElement
          ) : (
            <AvatarBase
              src={avatarSrc}
              size={AvatarSize.SM}
              backgroundColor={avatarBackgroundColor}
              hasDeleted={deleted}
            >
              {deleted ? <RemovePersonIcon /> : getAvatarText(primaryText)}
            </AvatarBase>
          )}
        </ListItemAvatar>
        <InfoContainer>
          <Stack direction="row" alignItems="center">
            <TextWithSkeleton text={primaryText}>
              <StyledPrimaryText variant="subtitle3" color="neutral900" noWrap>
                {primaryText}
              </StyledPrimaryText>
            </TextWithSkeleton>
            {verified && (
              <VerifiedAccount
                sx={{ color: 'primary500', width: '17px', height: '17px' }}
              />
            )}
          </Stack>
          <Typography color="neutral600" variant="caption1">
            {connectionStatus || secondaryText}
          </Typography>
        </InfoContainer>
      </StyledListItem>

      {hostConf.HAS_CALL_OPTION && callElement}
    </Container>
  )
}

export const RoomAppBarInfo = memo(RoomAppBarInfoComponent)
